import React from "react";
import "./DeviceInfoModal.css";
import { Modal } from "react-bootstrap";
import { titles } from "constants/titles";
import { CrossIconBtn } from "assets/SVGs/SVGs";

const DeviceInfoModal = ({
  show,
  setShow,
  selectedDeviceDetails,
  deviceSchema,
}) => {
  const deviceType = selectedDeviceDetails?.device_type?.trim();

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal
      backdrop="true"
      aria-labelledby="contained-modal-title-vcenter"
      className="di_container"
      show={show}
      onHide={handleClose}
    >
      <Modal.Body className="di_body">
        <div className="di_header">
          <CrossIconBtn
            className="di_cross_icon"
            onClick={() => setShow(!show)}
          />
        </div>

        <div className="di_content">
          {deviceType !== "clairvoyant" && (
            <div className="di_info_item">
              <h4 className="di_info_title">{titles?.auto_fall_detection}</h4>
              <p className="di_info_value">
                {deviceSchema?.autoFallDetection ? "Activated" : "Not Activated"}
              </p>
            </div>
          )}

          <div className="di_info_item">
            <h4 className="di_info_title">{titles?.device_id}</h4>
            <p className="di_info_value">{deviceSchema?.deviceId}</p>
          </div>

          {deviceSchema?.networkProvider && (
            <div className="di_info_item">
              <h4 className="di_info_title">{titles?.network_provider}</h4>
              <p className="di_info_value">{deviceSchema?.networkProvider}</p>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeviceInfoModal;
